import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BusinessRoutingModule } from './business-routing.module';
import { AddComponent } from './add/add.component';
import { EditComponent } from './edit/edit.component';
import { ListComponent } from './list/list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { ViewComponent } from './view/view.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CollegeReportComponent } from './college-report/college-report.component';
import { CompanyReportComponent } from './company-report/company-report.component';
import { ClientReportComponent } from './client-report/client-report.component';
import { ClientListComponent } from './client-list/client-list.component';
import { ArchwizardModule } from 'angular-archwizard';
import { NgxMaskModule } from 'ngx-mask';
import { ClientAddComponent } from './client-add/client-add.component';
import { MatMenuModule } from '@angular/material/menu';
import { QuillModule } from 'ngx-quill';

@NgModule({
  declarations: [
    AddComponent,
    EditComponent,
    ListComponent,
    ViewComponent,
    CollegeReportComponent,
    CompanyReportComponent,
    ClientReportComponent,
    ClientListComponent,
    ClientAddComponent,
  ],
  imports: [
    CommonModule,
    BusinessRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    SwiperModule,
    PipeModule,
    NgxDatatableModule,  
    MatSlideToggleModule,
    NgxSpinnerModule,
    ArchwizardModule,
    NgxMaskModule.forRoot(),
    MatMenuModule,
    QuillModule.forRoot(),


  ]
})
export class BusinessModule { }
